module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/serum_4c22e7.png";